module.exports = {"152571101":"巴彦胡硕镇","152571500":"哈拉盖图农牧场","152571501":"贺斯格乌拉牧场","152571502":"乌拉盖牧场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/152571.json
// module id = 583
// module chunks = 0